import { z } from 'zod'

export const adminRoleSchema = z.enum(['super_admin', 'general_admin'])
export type AdminRole = z.infer<typeof adminRoleSchema>

export const adminStatusSchema = z.enum(['active', 'inactive', 'suspended'])
export type AdminStatus = z.infer<typeof adminStatusSchema>

export const adminLoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1).max(200),
  totp_code: z.string().trim().min(6).max(8).optional(),
})

export const createAdminUserSchema = z.object({
  name: z.string().trim().min(2).max(255),
  email: z.string().email(),
  password: z.string().min(12).max(200),
  role: adminRoleSchema,
})

export const updateAdminUserSchema = z.object({
  name: z.string().trim().min(2).max(255).optional(),
  email: z.string().email().optional(),
  role: adminRoleSchema.optional(),
  status: adminStatusSchema.optional(),
})

export const adminChangePasswordSchema = z.object({
  password: z.string().min(12).max(200),
})

export type AdminLoginInput = z.infer<typeof adminLoginSchema>
export type CreateAdminUserInput = z.infer<typeof createAdminUserSchema>
export type UpdateAdminUserInput = z.infer<typeof updateAdminUserSchema>

export type AdminPermissionResponse = {
  can_view_financials: boolean
  can_manage_admins: boolean
  can_export_data: boolean
}

export type AdminUserResponse = {
  id: string
  name: string
  email: string
  role: AdminRole
  status: AdminStatus
  last_login_at?: string | null
  created_at: string
  updated_at: string
}

export type AdminLoginResponse = {
  success: boolean
  data: {
    admin: Pick<AdminUserResponse, 'id' | 'name' | 'email' | 'role'>
    token: string
    permissions: AdminPermissionResponse
  }
}
